// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDPgXUkZXiAkoE03kul2H0TQJG7qycqFF0",
  authDomain: "netsave-crm.firebaseapp.com",
  projectId: "netsave-crm",
  storageBucket: "netsave-crm.firebasestorage.app",
  messagingSenderId: "364651735859",
  appId: "1:364651735859:web:2a23e998c964f5d6336c46",
  measurementId: "G-99LQZKZ0J1"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export default app;
